// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCUYmqhwVFn_8dnbBEQVIsH3GQi1_tteis",
    authDomain: "msti-843c4.firebaseapp.com",
    projectId: "msti-843c4",
    storageBucket: "msti-843c4.appspot.com",
    messagingSenderId: "385376382078",
    appId: "1:385376382078:web:903af1f8e3136838327c2f",
    measurementId: "G-70ZJ02680P"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)